import { render, staticRenderFns } from "./dialogEditPurchaser.vue?vue&type=template&id=4b2a50a2&scoped=true"
import script from "./dialogEditPurchaser.vue?vue&type=script&lang=js"
export * from "./dialogEditPurchaser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2a50a2",
  null
  
)

export default component.exports